import React from 'react'
import { useMediaQuery } from 'react-responsive';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


export const SectionTwo = () => {

    const fullImageSliderSettings = {
        autoplay: true,
        autoplaySpeed: 5000, // 5 seconds
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      };
      
      const icons = [
        { label: 'WhatsApp', icon: '/assets/images/kwikengage/whatsapp.png' },
        { label: 'Email', icon: '/assets/images/kwikengage/message.png' },
        { label: 'SMS', icon: '/assets/images/kwikengage/chat.png' },
        { label: 'Instagram', icon: '/assets/images/kwikengage/insta.png' },
        { label: 'Website Chat', icon: '/assets/images/kwikengage/web.png' },
        { label: 'Mobile Push', icon: '/assets/images/kwikengage/facebook.png' },
      
      ];
    
      const features = [
        'Abandoned cart messaging',
        'Funnel retargeting',
        'Post purchase journey',
        'Pre purchase journey',
        'Whatsapp catalog',
        'Click-to-Whatsapp ads',
        'One-stop support desk',
        'Sale promotions',
        'Campaign automation',
      ];
      
      const sections1 = [
        {id:1,image:"/assets/images/kwikengage/baner1.png"},
        {id:2,image:"/assets/images/kwikengage/baner2.png"},
        {id:3,image:"/assets/images/kwikengage/baner3.png"},
        {id:4,image:"/assets/images/kwikengage/baner4.png"},
      ];
    

     const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className="section-2">
    <div className="container-fluid">
      
        <div className="top-text">
          <h1>GoKwik Network Effect</h1>

          {
            isMobile ? 
            <>
             <p>
            Leveraging the deepest pool of shoppers to build industry-best
            solutions  with AI-powered website visitor tracking tools
          </p>
            </>:
              <p>
                Leverage the most extensive network of online shoppers to maximize engagement and conversions.
            </p>
          }
        
        </div>
      

      {/* Key Metrics */}

        <div className="row d-flex justify-content-center mt-5" >
          <div className="details" style={{backgroundColor:'#0A194E'}}>
            <div className="accurate d-flex same">
              <h1>1.4Bn+</h1>
              {
                isMobile ? <p  className="mobile">
               Conversations
                </p> :
                 <p>
                 Conversations
                 </p>
              }
             
            </div>
            <div className="line"></div>
            <div className="d-flex same">
              <h1>{`>`}20%</h1>
              <p>
              Abandoned  <br />
              Cart Recovery
              </p>
            </div>
            <div className="line"></div>
            <div className="active d-flex same">
              <h1>3X</h1>
              <p>
              User <br /> Engagement
              </p>
            </div>

            <div className="line"></div>
            <div className="d-flex same">
              <h1>20X</h1>
              <p>
              ROAS
              </p>
            </div>


          </div>
        </div>


      <div className="container-fulid fourth">
        
          <div className="top-text growth">
            <h1>One solution for all your growth needs</h1>
            <p>
            Accelerate every stage of your growth funnel with a unified, end-to-end solution.
            </p>
          </div>

        <div className="growth-wrapper">
      <div className="growth-inner">
        {/* Left Side */}
        <div className="growth-left">
          <h3>Marketing, Retention, and Support</h3>
          <p style={{ width: "400px", margin: "0 auto", textAlign: "left" ,paddingLeft:"10px"}}>
            Power your brand's entire lifecycle with a unified solution built to attract, engage, and support customers at every stage of their journey.
          </p>
          <div className="icon-grid">
            {icons.map((item, index) => (
              <div key={index} className="icon-box">
                <span className="icon"><img src={item.icon} alt=""/></span>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side */}
        <div className="growth-right">
          <ul>
            {features.map((feature, idx) => (
              <li key={idx}>
                <span className="checkmark">  <img src="/assets/images/kwikengage/checkmark.png" alt="checkmark" /></span> {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
    

      </div>
  </div>

  <div className="container-fluid fourth d-flex justify-content-center align-items-center">


  </div>

      <div className="container-fulid fourth mb-5">

          <div className="top-text growth">
            <h1>Engage | Automate | Convert <br/>
            The Smarter Way to Drive Revenue</h1>
            <p className="mt-4 mb-5">
            With Kwik Pass, the most advanced website visitor tracking app, every click counts toward <br /> higher growth.
            </p>
          </div>


          <div className="d-flex justify-content-center">
              {isMobile ? (
                 // ✅ MOBILE VIEW — only slider
              <div style={{ width: '100%', maxWidth: '100%', padding: '0 5px', display:'flex',justifyContent:"center" }}>
              <Slider {...fullImageSliderSettings}>
                <div>
                  <img src="/assets/images/kwikengage/baner1.png" alt="Banner1" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikengage/baner2.png" alt="Banner2" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikengage/baner3.png" alt="Banner3" className="slide-ban-image " />
                </div>
                <div>
                  <img src="/assets/images/kwikengage/baner4.png" alt="Banner4" className="slide-ban-image " />
                </div>
               
              </Slider>
            </div>
              ) : (
                // ✅ DESKTOP VIEW — animated image banners
                <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{ 
          clickable: true,
          dynamicBullets: true 
        }}
        // navigation={true}
        modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
        className="mySwiper"
      >
        {sections1.map((section) => (
          <SwiperSlide key={section.id}>
            <div className="slide-wrapper">
              <img 
                className="slide-image" 
                src={section.image} 
                alt={`slide_image_${section.id}`} 
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '500px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
              )}
            </div>
            </div> 

          </div>    
  )
}


